import styled from 'styled-components';

export const FormContainer = styled.div`
  margin-top: 2rem;
`;
